import { useAuthBearerFetch } from "matsuri-hooks"
import { useAuth } from "m2m-components/storage/useM2mAuth"
import { getTTLockKeyNumberByListingId } from "@/endpoints/m2m-cleaning.cleaner-v4"

interface UseTTLockKeyNumberInput {
    listingId: string | undefined
}

interface UseTTLockKeyNumberOutput {
    keyNumber: string | undefined
}

export const useTTLockKeyNumber = ({ listingId }: UseTTLockKeyNumberInput) => {
    const { token } = useAuth()
    const endpoint = getTTLockKeyNumberByListingId
    const result = useAuthBearerFetch<UseTTLockKeyNumberOutput>(
        token,
        listingId ? endpoint({ listingId }) : null,
        {
            method: endpoint.method,
            swrConfig: {
                shouldRetryOnError: false
            }
        }
    )

    return result
}
